import { useContext, useSyncExternalStore } from 'react'

import { type ThreadState, useThread } from '@assistant-ui/react'
import { noop } from 'es-toolkit'

import { ChatEnvironmentStoreContext } from '@/components/chat-v2/providers/ChatEnvironmentProvider'

const selectIsRunning = (state: ThreadState) => state.isRunning
const subscribeToNothing = () => noop

/**
 * Whether the chat around this view is answering, or still starting the new
 * chat its first message makes; false outside a chat.
 */
export const useChatIsRunning = (): boolean => {
  const running = useThread({ optional: true, selector: selectIsRunning })
  const store = useContext(ChatEnvironmentStoreContext)
  const starting = useSyncExternalStore(
    store?.subscribe ?? subscribeToNothing,
    () => store?.getState().submitPending ?? false,
    // Nothing is starting on the server: the send that starts a chat is a click.
    () => false,
  )
  return !!running || starting
}
